import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=bb9156ec&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=ts"
export * from "./AboutView.vue?vue&type=script&lang=ts"
import style0 from "./AboutView.vue?vue&type=style&index=0&id=bb9156ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9156ec",
  null
  
)

export default component.exports